import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, null, -1 /* HOISTED */)
const _hoisted_7 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_link = _resolveComponent("b-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.authenticationError)
          ? (_openBlock(), _createBlock(_component_b_alert, {
              key: 0,
              show: "",
              "data-cy": "loginError",
              variant: "danger",
              innerHTML: _ctx.t$('login.messages.error.authentication')
            }, null, 8 /* PROPS */, ["innerHTML"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_b_form, {
          role: "form",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.doLogin()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, {
              label: _ctx.t$('global.form[\'username.label\']'),
              "label-for": "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_input, {
                  id: "username",
                  type: "text",
                  name: "username",
                  autofocus: "",
                  placeholder: _ctx.t$('global.form[\'username.placeholder\']'),
                  modelValue: _ctx.login,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login) = $event)),
                  "data-cy": "username"
                }, null, 8 /* PROPS */, ["placeholder", "modelValue"])
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createVNode(_component_b_form_group, {
              label: _ctx.t$('login.form.password'),
              "label-for": "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_input, {
                  id: "password",
                  type: "password",
                  name: "password",
                  placeholder: _ctx.t$('login.form[\'password.placeholder\']'),
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  "data-cy": "password"
                }, null, 8 /* PROPS */, ["placeholder", "modelValue"])
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createVNode(_component_b_form_checkbox, {
              id: "rememberMe",
              name: "rememberMe",
              modelValue: _ctx.rememberMe,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event)),
              checked: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  textContent: _toDisplayString(_ctx.t$('login.form.rememberme'))
                }, null, 8 /* PROPS */, _hoisted_5)
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            _createElementVNode("div", null, [
              _createVNode(_component_b_button, {
                "data-cy": "submit",
                type: "submit",
                variant: "primary",
                textContent: _toDisplayString(_ctx.t$('login.form.button'))
              }, null, 8 /* PROPS */, ["textContent"])
            ])
          ], undefined, true),
          _: 1 /* STABLE */
        }),
        _hoisted_6,
        _createElementVNode("div", null, [
          _createVNode(_component_b_alert, {
            show: "",
            variant: "warning"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_link, {
                to: '/account/reset/request',
                class: "alert-link",
                textContent: _toDisplayString(_ctx.t$('login.password.forgot')),
                "data-cy": "forgetYourPasswordSelector"
              }, null, 8 /* PROPS */, ["textContent"])
            ], undefined, true),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_b_alert, {
            show: "",
            variant: "warning"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.t$('global.messages.info.register.noaccount'))
              }, null, 8 /* PROPS */, _hoisted_7),
              _createVNode(_component_b_link, {
                to: '/register',
                class: "alert-link",
                textContent: _toDisplayString(_ctx.t$('global.messages.info.register.link'))
              }, null, 8 /* PROPS */, ["textContent"])
            ], undefined, true),
            _: 1 /* STABLE */
          })
        ])
      ])
    ])
  ]))
}